import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, TouchableOpacity } from 'react-native';

import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const UpsellBackdrop = (props: UpsellBackdropProps) => {
  const { onPress } = props;

  const { formatMessage } = useIntl();

  return (
    <TouchableOpacity
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={formatMessage(messages.a11yLabel)}
      style={styles.backdrop}
    />
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  a11yLabel: {
    defaultMessage: 'Close modal',
    description: 'Upsell modal | Backdrop close modal accessibility label',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  backdrop: {
    ...StyleSheet.absoluteFill,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.DARKER,
  },
});

// ─────────────────────────────────────────────────────────────────────────────

type UpsellBackdropProps = {
  onPress: () => void;
};
